<div class="container">
    <div class="close-btn" >
        <img src="assets/icon/clear.svg" alt="close" (click)="continue();crossBtnGA()">
    </div>
    <div class="content">
        <h5 class="text-center">Sorry. We are unable to process your payment.</h5>
    </div>
    <div class="button text-center">
        <button (click)="continue()">Ok</button>
    </div>
 </div>